import { ShipShape } from '@components/Renderable';
import { getShipGeometry } from '@renderSystems/ShipShapes';
import { shadeColor, tintColor } from '@utils/ColorUtils';

/** Paints a small nose-up hull icon, in the combat style, onto a canvas element. */
export function drawHullIcon(canvas: HTMLCanvasElement, shape: ShipShape, color: string): void {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const { width, height } = canvas;
  const size = Math.min(width, height) * 0.32;
  const geometry = getShipGeometry(shape);

  ctx.clearRect(0, 0, width, height);
  ctx.save();
  ctx.translate(width / 2, height / 2);
  ctx.rotate(-Math.PI / 2);

  ctx.beginPath();
  geometry.hull.forEach((p, i) => (i === 0 ? ctx.moveTo(p.x * size, p.y * size) : ctx.lineTo(p.x * size, p.y * size)));
  ctx.closePath();
  const gradient = ctx.createLinearGradient(size * 1.2, 0, -size, 0);
  gradient.addColorStop(0, tintColor(color, 0.35));
  gradient.addColorStop(0.45, color);
  gradient.addColorStop(1, shadeColor(color, 0.4));
  ctx.fillStyle = gradient;
  ctx.shadowColor = color;
  ctx.shadowBlur = 6;
  ctx.fill();
  ctx.shadowBlur = 0;
  ctx.strokeStyle = tintColor(color, 0.5);
  ctx.lineWidth = 1;
  ctx.stroke();

  if (geometry.cockpit) {
    const c = geometry.cockpit;
    ctx.fillStyle = c.color;
    ctx.beginPath();
    ctx.ellipse(c.x * size, c.y * size, c.rx * size, c.ry * size, 0, 0, Math.PI * 2);
    ctx.fill();
  }

  ctx.fillStyle = geometry.engineColor;
  for (const engine of geometry.engines) {
    ctx.beginPath();
    ctx.arc(engine.x * size, engine.y * size, Math.max(1, size * 0.1), 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.restore();
}
